import { useIntl } from "react-intl";
import {
  Modal,
  Box,
  Typography,
  Grid,
  FormControlLabel,
  FormLabel,
  Button,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useLoading } from "../../../components/LoadingContext";
import { errorToast, handleError } from "../../../services/serviceBase";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { setActAs } from "../../../redux/actasSlice";
import { FormControl, Radio, RadioGroup } from "@mui/material";
import toast from "react-hot-toast";

import PageHeader from "../../ui/PageHeader";
import CustomInput from "../../ui/CustomInput";
import axios from "../../../api/axiosClient";
import * as apiService from "../../../services/apiService";

export default function AcceptModal(props) {
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const intl = useIntl();
  const idCompany = useSelector((state) => state.common.company);

  const [couriers, setCouriers] = useState([]);
  const [courier, setCourier] = useState({ text: "", value: "" });

  const [shippingConditions, setShippingConditions] = useState([]);
  const [shippingCondition, setShippingCondition] = useState({
    text: "",
    value: "",
  });

  const [shippingMethods, setShippingMethods] = useState([]);
  const [shippingMethod, setShippingMethod] = useState({
    text: "",
    value: "",
  });

  const [pickupDate, setPickupDate] = useState(null);
  const [numOfBox, setNumOfBox] = useState(null);

  const [createdReturnFileIds, setCreatedReturnFileIds] = useState([]);

  const modalStyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "white",
    boxShadow: 24,
    width: "70%",
    height: "40%",
    overflow: "auto",
    p: 4,
    borderRadius: "5px",
  };

  useEffect(() => {
    const loadDropdownData = async () => {
      try {
        getCouriers();
        getShippingConditions();
        getShippingMethods();
      } finally {
        setLoading(false);
      }
    };

    loadDropdownData();
  }, []);

  const handleClose = () => {
    props.handleCloseModal();
  };

  const getCouriers = () => {
    axios
      .get(`/creditnotereturnfiles/${idCompany}/couriers`)
      .then((response) => {
        setLoading(false);
        var data = [];
        if (response.data !== undefined) {
          response.data.map((x) => {
            data.push({
              value: x.idCourier,
              text: `${x.courierCode} - ${x.courierDescription}`,
            });
            return null;
          });
        }
        setCouriers(data);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getShippingConditions = () => {
    axios
      .get(`/creditnotereturnfiles/${idCompany}/shippingConditions`)
      .then((response) => {
        setLoading(false);
        var data = [];
        if (response.data !== undefined) {
          response.data.map((x) => {
            data.push({
              value: x.idShippingCondition,
              text: x.description,
            });
            return null;
          });
        }
        setShippingConditions(data);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getShippingMethods = () => {
    axios
      .get(`/creditnotereturnfiles/${idCompany}/shippingmethods`)
      .then((response) => {
        setLoading(false);
        var data = [];
        if (response.data !== undefined) {
          response.data.map((x) => {
            data.push({
              value: x.idShippingMethod,
              text: x.description,
            });
            return null;
          });
        }
        setShippingMethods(data);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleCloseAndRedirect = () => {
    props.handleCloseModal();
    navigate(`${process.env.PUBLIC_URL}/RADetail/${props.idReturnFileHead}`);
  };

  const handleAcceptReturnFile = (e) => {
    e.preventDefault();
    if (
      courier.value == "" ||
      shippingCondition.value == "" ||
      shippingMethod.value == "" ||
      pickupDate == null ||
      numOfBox == null
    ) {
      toast.error(intl.formatMessage({ id: "Error.ValidationAcceptModal" }));
      return;
    }
    var data = {
      IdCourier: courier.value,
      IdShippingCondition: shippingCondition.value,
      IdShippingMethod: shippingMethod.value,
      PickUpDate: pickupDate,
      NumOfBox: numOfBox,
    };

    setLoading(true);
    apiService.acceptReturnFile(
      props.idReturnFileHead,
      data,
      (response) => {
        setLoading(false);
        toast.success("Saved!");
        setCreatedReturnFileIds(response);
        handleCloseAndRedirect();
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      }
    );
  };

  return (
    <Modal open={props.openModal} onClose={handleClose}>
      <Box sx={modalStyle}>
        <PageHeader title={props.modalHeaderText} />
        <Grid container spacing={3} mt={1} mb={1}>
          <Grid item md={6} xs={12}>
            <CustomInput
              labelText={intl.formatMessage({
                id: "RAPreparing.Accept.Feeder",
              })}
              type="autocomplete"
              value={courier}
              selectItems={couriers}
              setValue={setCourier}
              textCol={3}
              inputCol={9}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <CustomInput
              labelText={intl.formatMessage({
                id: "RAPreparing.Accept.PickUpDate",
              })}
              type="date"
              valueRef={pickupDate}
              setValue={setPickupDate}
              textCol={3}
              inputCol={9}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <CustomInput
              labelText={intl.formatMessage({
                id: "RAPreparing.Accept.ShippingConditions",
              })}
              type="autocomplete"
              value={shippingCondition}
              selectItems={shippingConditions}
              setValue={setShippingCondition}
              textCol={3}
              inputCol={9}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <CustomInput
              labelText={intl.formatMessage({
                id: "RAPreparing.Accept.NumOfBox",
              })}
              type="number"
              value={numOfBox}
              setValue={setNumOfBox}
              textCol={3}
              inputCol={9}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <CustomInput
              labelText={intl.formatMessage({
                id: "RAPreparing.Accept.ShippingMethod",
              })}
              type="autocomplete"
              value={shippingMethod}
              selectItems={shippingMethods}
              setValue={setShippingMethod}
              textCol={3}
              inputCol={9}
            />
          </Grid>
        </Grid>
        <Grid container>
          <Grid item md={12} display="flex" justifyContent="flex-end">
            <Button
              variant="contained"
              className="apeLigthBlueBackground"
              onClick={handleAcceptReturnFile}
            >
              {intl.formatMessage({ id: "General.Save" })}
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}
